<template>
  <el-container v-title data-title="年费统计" style="min-height:98vh">
    <el-header style="text-align: right; font-size: 12px; height: 105px; background-image: linear-gradient(to right, white , green);">
      <Top/>
    </el-header>
    <el-container>
      <el-aside width="200px" style="background-color: rgb(238, 241, 246)">
        <Menu @GoTo='goto'></Menu>
      </el-aside>
      <el-main style="width: 1px">
        <el-header style="height: auto; padding: 0; background-color: #FFF">
          <el-container>
            <el-header height="20px" style="padding: 0; background-color: #FFF">
              <el-breadcrumb separator="/">
                <el-breadcrumb-item>财务管理</el-breadcrumb-item>
                <el-breadcrumb-item>年费统计</el-breadcrumb-item>
              </el-breadcrumb>
            </el-header>
            <el-main>
              <el-form :inline="true" :model="searchForm" class="demo-form-inline">
                <el-form-item>
                  <el-button type="primary" :loading="isDownloading" @click="downloadStatYearFee">下载</el-button>
                </el-form-item>
              </el-form>
            </el-main>
          </el-container>
        </el-header>
        <el-table v-loading="loading" :data="tableData" border stripe>
          <el-table-column prop="schoolName" label="学校" width="220"></el-table-column>
          <el-table-column prop="studentQty" label="总人数（含教师子女及特困生）" width="100"></el-table-column>
          <el-table-column prop="freeStudentQty" label="教师子女及特困生人数" width="100"></el-table-column>
          <el-table-column prop="allPaidQty" label="总缴费人数（含教师子女及特困生）" width="100"></el-table-column>
          <el-table-column prop="allPaidRate" label="总缴费率（总缴费人数 / 总人数）" width="100"></el-table-column>
          <el-table-column prop="expectedPayQty" label="应缴费人数（不含教师子女及特困生）" width="100"></el-table-column>
          <el-table-column prop="expectedPaidQty" label="应缴已缴费人数" width="100"></el-table-column>
          <el-table-column prop="expectedUnpaidQty" label="应缴未缴费人数" width="100"></el-table-column>
          <el-table-column prop="expectedPaidRate" label="应缴费人数的缴费率" width="100"></el-table-column>
          <el-table-column prop="paidAmount" label="总缴费金额（仅年费，包含已退款）" width="100"></el-table-column>
          <el-table-column prop="refundAmount" label="总退款金额（仅年费）" width="100"></el-table-column>
        </el-table>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import Top from './Top.vue'
import Menu from './Menu.vue'
export default ({
  components: {
    Menu,
    Top
  },
  data () {
    return {
      userInfo: {},
      tableData: [],
      loading: false,
      isDownloading: false,
      currentPage: 1,
      pageSize: 15,
      pageSizes: [15, 50, 100, 150, 200, 300, 500, 1000, 2000],
      total: 0,
      searchForm: {},
      schoolList: []
    }
  },
  mounted () {
    if (this.Cookie.get('userInfo') !== undefined && this.Cookie.get('userInfo') !== '') {
      this.userInfo = JSON.parse(this.Cookie.get('userInfo'))
      this.statYearFee()
    }
  },
  methods: {
    goto (url) {
      if (url === this.$route.path) return
      this.$router.push(url)
    },
    statYearFee () {
      let _this = this
      _this.loading = true
      this.$axios.post(this.GLOBAL.host + '/order/statYearFee').then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.tableData = res.data.data
          } else {
            this.$message.error(res.data.message)
          }
        }
        _this.loading = false
      })
    },
    downloadStatYearFee () {
      if (this.month === '') return
      let _this = this
      _this.isDownloading = true
      this.$axios.post(this.GLOBAL.host + '/order/downloadYearFeeStat', this.$qs.stringify({
        schoolId: _this.searchForm.schoolId
      }), {
        responseType: 'blob'
      }).then(res => {
        if (res.data != null) {
          let errorMessage = ''
          let reader = new FileReader()
          reader.onload = function () {
            try {
              let response = JSON.parse(reader.result)
              if (response != null && response.message != null) {
                errorMessage = response.message
                console.log('errorMessage-111111')
                console.log('errorMessage: ' + errorMessage)
                _this.$message.error(errorMessage)
              }
            } catch (e) {
              let contentDisposition = res.headers['content-disposition']
              console.log(contentDisposition)
              let fileName = window.decodeURI(contentDisposition.substring(contentDisposition.indexOf('=') + 1))
              let blob = new Blob([res.data], {type: 'application/vnd.ms-excel'})
              let url = window.URL.createObjectURL(blob)
              const link = document.createElement('a')
              link.href = url
              link.download = fileName // 重命名文件
              link.click()
              URL.revokeObjectURL(url) // 释放内存
            }
          }
          reader.readAsText(res.data)
        }
        _this.isDownloading = false
      })
    }
  }
})
</script>



// WEBPACK FOOTER //
// src/components/StatsForYearFee.vue